import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SubagentStatusComponent} from './subagent-status.component';
import {PopoverModule} from '../../modules/@popover/popober.module';

@NgModule({
  imports: [
    CommonModule,
    PopoverModule,
  ],
  declarations: [
    SubagentStatusComponent,
  ],
  exports: [
    SubagentStatusComponent,
  ]
})
export class SubagentStatusModule { }
